import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center h-full" }
const _hoisted_2 = { class: "flex items-center justify-center text-primary-400" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-3xl text-primary-400" }, " Agregar comunidad ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_ComponentCard = _resolveComponent("ComponentCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ComponentCard, { class: "w-80 h-[380px] pointe bg-primary-100 bg-opacity-20 border-primary-100 border-4 flex items-center justify-center" }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_mdicon, {
              name: "plus-thick",
              size: "100"
            })
          ]),
          _hoisted_3
        ])
      ]),
      _: 1
    })
  ]))
}